<template>
  <div>
    <!-- begin loading -->
    <div v-if="pageLoading" class="page-loading-container">
      <v-progress-circular
        :size="60"
        :width="5"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>
    <!-- end loading -->

    <!-- begin 商品详情 -->
    <div class="wrapper" v-show="!pageLoading">
      <v-container class="delivery-container">
        <v-layout class="delivery-summary">
          <div class="cover-container">
            <v-carousel>
              <v-carousel-item
                class="cover"
                :src="item.url"
                :key="index"
                v-for="(item, index) in delivery.images"
              >
              </v-carousel-item>
            </v-carousel>
          </div>
          <div class="summary-container">
            <h1 class="delivery-name">
              {{ delivery.name }}
            </h1>
            <div class="delivery-price">
              €{{ delivery.price | fixed(2, true) }}
            </div>
            <div class="summary">
              {{ delivery.description }}
            </div>
          </div>

          <!-- begin 备注 属性选择 -->
          <div class="attributes-container">
            <div class="attributes-title">
              <div>{{ $t("delivery_detail.remark") }}：</div>
              <!-- <input placeholder="输入或选择备注" /> -->
            </div>
            <div class="attributes-content">
              <div
                v-for="(item, index) in delivery.attributes"
                :key="index"
                :class="{ item: true, active: item.check }"
                @click="checkAttr(item)"
              >
                {{ item.name }}
              </div>
            </div>
          </div>
          <!-- begin 备注 属性选择 -->

          <!-- begin 选择数量 -->
          <div
            class="form-container"
            v-if="
              delivery.garnish &&
                delivery.garnish.length == 0 &&
                storeInfo.orderScanner == 1
            "
          >
            <v-layout
              class="form-group"
              v-if="currentCart && currentCart.num > 0"
            >
              <v-btn
                fab
                dark
                outline
                small
                color="primary"
                class="stepper"
                @click="handleMinusFromCart"
              >
                <v-icon dark>remove</v-icon>
              </v-btn>
              <v-flex xs2>
                <div class="goods-num">{{ currentCart.num }}</div>
              </v-flex>
              <v-btn
                fab
                dark
                outline
                small
                color="primary"
                class="stepper"
                @click="handleAddToCart"
              >
                <v-icon dark>add</v-icon>
              </v-btn>
            </v-layout>
            <v-layout
              class="form-group"
              v-if="!currentCart || currentCart.num <= 0"
            >
              <v-btn
                fab
                dark
                outline
                small
                color="primary"
                class="stepper"
                @click="handleAddToCart"
              >
                <v-icon dark>add</v-icon>
              </v-btn>
            </v-layout>
          </div>
          <!-- end 选择数量 -->
        </v-layout>
      </v-container>
    </div>
    <!-- end 商品详情 -->

    <div class="bottom-btn" @click="handleBack">
      {{
        !currentCart || currentCart.num <= 0
          ? $t("delivery_detail.back")
          : $t("delivery_detail.confirm")
      }}
    </div>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, integer, minValue } from "vuelidate/lib/validators";
import { mapGetters, mapMutations, mapActions, mapState } from "vuex";
import { fixed } from "../../../utils";

export default {
  mixins: [validationMixin],
  validations: {
    num: { required, integer, minValue: minValue(1) }
  },
  data() {
    return {
      added: false,
      pageLoading: false
    };
  },
  mounted() {
    this.initData();
  },
  computed: {
    ...mapGetters({
      delivery: "currentDelivery"
    }),
    ...mapGetters(["cart"]),
    ...mapState(["carts", "storeInfo"]),

    currentCart() {
      return this.cart.items.find(item => item.guid === this.delivery.guid);
    }
  },
  methods: {
    ...mapMutations(["addToCart", "minusFromCart", "setDelivery", "resetCart"]),
    ...mapActions(["getDeliveryDetail"]),
    handleAddToCart() {
      this.addToCart({
        num: 1,
        guid: this.delivery.guid
      });
    },
    handleMinusFromCart() {
      this.minusFromCart({
        num: 1,
        guid: this.delivery.guid
      });
    },
    async initData() {
      this.pageLoading = true;
      const guid = this.$route.params.id;
      await this.getDeliveryDetail({ guid });
      this.pageLoading = false;
    },
    handleBack() {
      this.$router.back();
    },

    /**
     * 选择属性标签
     */
    checkAttr(item) {
      let attributes = this.delivery.attributes;

      attributes.map((att_item, index) => {
        if (att_item.guid == item.guid) {
          attributes[index].check = !attributes[index].check;
        }
      });

      let cart_attributes = [];
      attributes.map(item1 => {
        if (item1.check) {
          cart_attributes.push(item1.guid);
        }
      });

      let carts = this.carts;

      carts.map((item1, index) => {
        if (item1.guid == this.delivery.guid) {
          carts[index].attributes = cart_attributes;
        }
      });

      this.resetCart(carts);

      this.setDelivery({
        ...this.delivery,
        attributes
      });
    }
  },
  filters: {
    fixed
  }
};
</script>

<style scoped lang="sass" src="./delivery-detail.sass"></style>
